
import React from 'react';
import ResourcePageLayout from '@/components/layouts/ResourcePageLayout';
import { AlertCircle, CheckCircle, Clock, Mail } from 'lucide-react';

const RefundPolicy = () => {
  const lastUpdated = "June 1, 2023";
  
  const sections = [
    {
      title: "Eligibility",
      icon: CheckCircle,
      content: "Refunds are available for subscription purchases within 14 days of the initial purchase or renewal date. One-time purchases of digital content may be eligible for refunds within 7 days of purchase if the content has not been accessed or downloaded. Premium features, add-ons, and in-app purchases follow the same 7-day refund window, subject to usage limitations."
    },
    {
      title: "Refund Process",
      icon: AlertCircle,
      content: "To request a refund, please contact our customer support team via email at refunds@hormonebalanceguide.com or through the 'Contact Us' form on our website. Please include your order number, email address associated with your account, date of purchase, and reason for requesting a refund. Our team will review your request and respond within 2-3 business days."
    },
    {
      title: "Timeframe",
      icon: Clock,
      content: "Approved refunds will be processed within 5-7 business days from the date of approval. The refund will be issued using the same payment method used for the original purchase. Depending on your payment provider, it may take additional time for the refunded amount to appear in your account."
    },
    {
      title: "Contact for Refunds",
      icon: Mail,
      content: "For any questions or issues regarding refunds, please contact our dedicated refund support team at refunds@hormonebalanceguide.com. Our support hours are Monday through Friday, 9:00 AM to 5:00 PM Pacific Time, excluding holidays. We aim to address all refund-related inquiries promptly and fairly."
    }
  ];
  
  return (
    <ResourcePageLayout 
      title="Refund Policy" 
      description="We want you to be satisfied with Hormone Balance Guide. Please read our refund policy below."
    >
      <div className="bg-white p-6 rounded-lg border border-Hormone Balance Guide-beige/50 mb-6">
        <p className="text-sm text-Hormone Balance Guide-charcoal/70">Last Updated: {lastUpdated}</p>
        <p className="mt-4 text-Hormone Balance Guide-charcoal/80">
          At Hormone Balance Guide, we strive to provide high-quality services and content that meet your expectations. We understand that circumstances may arise where you need to request a refund. This policy outlines our refund process, eligibility requirements, and other important information regarding refunds.
        </p>
      </div>
      
      <div className="space-y-6">
        {sections.map((section, index) => (
          <div key={index} className="bg-white p-6 rounded-lg border border-Hormone Balance Guide-beige/50">
            <div className="flex items-center gap-3 mb-3">
              <section.icon className="text-Hormone Balance Guide-coral" size={24} />
              <h3 className="text-xl font-semibold text-Hormone Balance Guide-charcoal">{section.title}</h3>
            </div>
            <p className="text-Hormone Balance Guide-charcoal/80">{section.content}</p>
          </div>
        ))}
      </div>
      
      <div className="mt-8 bg-Hormone Balance Guide-beige/20 p-6 rounded-lg border border-Hormone Balance Guide-beige">
        <h3 className="text-xl font-semibold text-Hormone Balance Guide-charcoal mb-3">Special Circumstances</h3>
        <p className="text-Hormone Balance Guide-charcoal/80">
          We understand that exceptional situations may occur. If you're experiencing an issue that isn't covered by our standard refund policy, please contact our customer support team to discuss your specific circumstances. We'll review each case individually and work toward a fair resolution.
        </p>
      </div>
    </ResourcePageLayout>
  );
};

export default RefundPolicy;
